import { Controller } from "@hotwired/stimulus"
import { confirmDialog } from "../helpers/swal_helper"
import ouibounce from "ouibounce"

export default class extends Controller {
  static values = { message: String, demoUrl: String }

  connect() {
    this.ouibounceInstance = ouibounce(document.body, {
      aggressive: true, // trigger on first exit
      callback: () => this.showDialog(),
    })
  }

  disconnect() {
    if (this.ouibounceInstance) {
      this.ouibounceInstance.disable()
    }
  }

  async showDialog() {
    const result = await confirmDialog({
      title: "Wait, don't leave just yet!",
      text: this.messageValue || "Before you go, sign up for e-Maktab!",
      confirmButtonText: "Try Demo",
    })

    if (result) {
      window.location.href = this.demoUrlValue;
    }
  }
}
